import { LayoutMicroCopy } from "./Layout"
import { FooterCopy } from "../Footer/Footer"
import { FooterNavCopy } from "../Footer/FooterBase"

export const FALLBACK_MICROCOPY: LayoutMicroCopy = {
  messageSearchBar: {
    microcopyKey: "messageSearchBar",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Search help articles","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  headerSearchResults: {
    microcopyKey: "headerSearchResults",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Results for","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  buttonContactUs: {
    microcopyKey: "buttonContactUs",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Contacto","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  buttonBrowseHelpCenter: {
    microcopyKey: "buttonBrowseHelpCenter",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Browse Help Center","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  messageContactUs: {
    microcopyKey: "messageContactUs",
    microcopyValue: {
      raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Still have questions? Contact support.","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
    }
  },
  upperNavMicroCopySet: {
    microcopySetEntries: [
      {
        microcopyKey: "navigationHomepage",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Help Center","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationLogIn",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Iniciar sesión","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationBrowseEvents",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Descubrir eventos","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationTickets",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Entradas","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationManageMyEvents",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Gestionar mis eventos","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationAccountSettings",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Ajustes de la cuenta","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      },
      {
        microcopyKey: "navigationLogOut",
        microcopyValue: {
          raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"Cerrar sesión","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}'
        }
      }
    ]
  },
  chatbotUITranslations: {
    edges: []
  }
}

export const FALLBACK_FOOTERCOPY: FooterCopy = [
  {
    displayText: "Use Eventbrite",
    FooterNavigationChildItems: [
      {
        footerNavigationInternalTitle: null,
        displayText: "Create events",
        footerNavigationUrl: "https://www.eventbrite.com/organizer/overview/"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Pricing",
        footerNavigationUrl: "https://www.eventbrite.com/organizer/pricing/"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Content standards",
        footerNavigationUrl: "https://www.eventbrite.com/l/contentstandards/"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Site status",
        footerNavigationUrl: "http://www.eventbritestatus.com/"
      }
    ]
  },
  {
    displayText: "Download apps",
    FooterNavigationChildItems: [
      {
        footerNavigationInternalTitle: null,
        displayText: "Eventbrite app for iOS",
        footerNavigationUrl:
          "https://itunes.apple.com/us/app/eventbrite/id487922291"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Eventbrite app for Android",
        footerNavigationUrl:
          "https://play.google.com/store/apps/details?id=com.eventbrite.attendee&hl=en"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Eventbrite Organizer app",
        footerNavigationUrl:
          "https://www.eventbrite.com/l/organizer-check-in-app/"
      }
    ]
  },
  {
    displayText: "Browse resources",
    FooterNavigationChildItems: [
      {
        footerNavigationInternalTitle: null,
        displayText: "Taxes",
        footerNavigationUrl: "https://www.eventbrite.com/l/taxes/"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Marketing tutorials",
        footerNavigationUrl: "https://docs-eb.toneden.io/"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Webinars for new organizers",
        footerNavigationUrl:
          "https://www.eventbrite.com/o/eventbrite-academy-30396073460"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Reconvene virtual sessions for organizers",
        footerNavigationUrl: "https://www.eventbrite.com/reconvene/"
      }
    ]
  },
  {
    displayText: "Connect with us",
    FooterNavigationChildItems: [
      {
        footerNavigationInternalTitle: null,
        displayText: "Twitter",
        footerNavigationUrl: "https://twitter.com/eventbrite"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Facebook",
        footerNavigationUrl: "https://www.facebook.com/Eventbrite"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Instagram",
        footerNavigationUrl: "https://www.instagram.com/eventbrite/"
      },
      {
        footerNavigationInternalTitle: null,
        displayText: "Contact support",
        footerNavigationUrl: "https://www.eventbrite.com/help/contact-us"
      }
    ]
  }
]

export const FALLBACK_FOOTERNAVCOPY: FooterNavCopy = [
  {
    footerNavigationInternalTitle: null,
    displayText: "About",
    footerNavigationUrl: "https://www.eventbrite.com/about/"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Blog",
    footerNavigationUrl: "https://www.eventbrite.com/blog/"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Help",
    footerNavigationUrl: "https://www.eventbrite.com/help"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Careers",
    footerNavigationUrl: "https://www.eventbritecareers.com/home"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Press",
    footerNavigationUrl: "https://www.eventbrite.com/press"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Security",
    footerNavigationUrl: "https://www.eventbrite.com/security/"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Developers",
    footerNavigationUrl: "https://www.eventbrite.com/platform/"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Terms",
    footerNavigationUrl: "https://www.eventbrite.com/l/legalterms/"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Privacy",
    footerNavigationUrl: "https://www.eventbrite.com/privacypolicy/"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Accessibility",
    footerNavigationUrl: "https://www.eventbrite.com/l/accessibility/"
  },
  {
    footerNavigationInternalTitle: null,
    displayText: "Cookies",
    footerNavigationUrl: "https://eventbrite.com/cookies"
  }
]
